module.exports = __webpack_public_path__ + "img/mental3.6120cfd4.png";